import {Module} from 'vuex';
import {RootState} from '@/types';
import {namespace} from 'vuex-class';
import BiodataApi from '@/api/BiodataAPI';
import {
  SET_BIODATA,
  SET_BIODATAS,
  SET_LOCATION,
  SET_LOCATIONS,
  SET_LOCATIONS2,
  SET_DESEASE,
} from '@/store/mutationTypes';

export const biodataModule = namespace('biodata');
export interface Biodata {
  [key: string]: any;
}

interface BiodataState {
  biodatas: Biodata[];
  biodata: Biodata | null;
  locations: Biodata[];
  locations2: Biodata[];
  location: Biodata | null;
  desease: Biodata[];
}
export default <Module<BiodataState, RootState>>{
  namespaced: true,
  state: {
    biodatas: [],
    biodata: null,
    location: null,
    locations: [],
    locations2: [],
    desease: [],
  },
  mutations: {
    [SET_BIODATAS](state, data) {
      state.biodatas = data;
    },
    [SET_BIODATA](state, data) {
      state.biodata = data;
    },
    [SET_LOCATION](state, data) {
      state.location = data;
    },
    [SET_LOCATIONS](state, data) {
      state.locations = data;
    },
    [SET_LOCATIONS2](state, data) {
      state.locations2 = data;
    },
    [SET_DESEASE](state, data) {
      state.desease = data;
    },
  },
  actions: {
    async getBiodata({commit}, params = {}) {
      try {
        const {data} = await BiodataApi.getBiodata(params);
        commit(SET_BIODATAS, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getLocation({commit}, params = {}) {
      try {
        const {data} = await BiodataApi.getLocation(params);
        commit(SET_LOCATIONS, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getLocation2({commit}, params = {}) {
      try {
        const {data} = await BiodataApi.getLocation(params);
        commit(SET_LOCATIONS2, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getAddress({commit}, params = {}) {
      try {
        const {data} = await BiodataApi.getAddress(params);
        commit(SET_LOCATIONS, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getDesease({commit}, params = {}) {
      try {
        const {data} = await BiodataApi.getDesease(params);
        commit(SET_DESEASE, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async updateBiodata(_, payload) {
      try {
        const res = await BiodataApi.updateBiodata(payload);
        return res;
      } catch (e) {
        return e.response.data;
      }
    },
    async updateAddress(_, payload) {
      try {
        const res = await BiodataApi.updateAddress(payload);
        return res;
      } catch (e) {
        return e.response.data;
      }
    },
    async updateEmergency(_, payload) {
      try {
        const res = await BiodataApi.updateEmergency(payload);
        return res;
      } catch (e) {
        return e.response.data;
      }
    },
    async getEmergency(_, payload) {
      try {
        const {data} = await BiodataApi.getEmergency(payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async updateHealth(_, payload) {
      try {
        const res = await BiodataApi.updateHealth(payload);
        return res;
      } catch (e) {
        return e.response.data;
      }
    },
    async getHealth(_, payload) {
      try {
        const {data} = await BiodataApi.getHealth(payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
  },
};
